import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL submissionS
export const submissionList = (params = '') => Http.get(`/showcase-submissions${serialize(params)}`)
// Game name / studio name / Steam App ID CSV for the submissions matching
// `params` (typically just filter[showcase_event_id], the admin's event
// select) — same filter shape as submissionList.
export const submissionExportCsv = (params = '') => Http.get(`/showcase-submissions/export-csv${serialize(params)}`, { responseType: 'blob' })
export const submissionCreate = (params = '') => Http.post('/showcase-submissions', params)
export const submissionByID = (params = '') => Http.get(`/showcase-submissions/${params}`)
export const submissionUpdate = (params = '') => Http.put(`/showcase-submissions/${params.id}`, params)
export const submissionDestroy = (params = '') => Http.delete(`/showcase-submissions/${params.id}`)
export const submissionSendEmail = (payload) => Http.post(`/showcase-submissions/send-email`, payload)
export const submissionSendPaymentConfirmation = (payload) => Http.post(`/showcase-submissions/send-payment-confirmation`, payload)
// Manual dashboard-access override — independent of is_paid, for a studio whose
// invoice is real but hasn't credited yet (bank transfer/PIX can take days).
export const submissionGrantAccess = (id) => Http.post(`/showcase-submissions/${id}/grant-access`)
export const submissionRevokeAccess = (id) => Http.delete(`/showcase-submissions/${id}/grant-access`)

const submissionCountsCache = new Map()

// STATS - fetch counts using per_page=1 to get only pagination totals
export const submissionCounts = async (showcaseEventId = null) => {
	const cacheKey = showcaseEventId || 'all'
	const cached = submissionCountsCache.get(cacheKey)
	if (cached) return cached

	const base = { per_page: 1, sort: 'id', order: 'desc' }
	if (showcaseEventId) base['filter[showcase_event_id]'] = showcaseEventId

	const [paidRes, unpaidRes] = await Promise.all([
		Http.get(`/showcase-submissions${serialize({ ...base, 'filter[is_paid]': 1 })}`),
		Http.get(`/showcase-submissions${serialize({ ...base, 'filter[is_paid]': 0 })}`),
	])

	const counts = {
		paid: paidRes?.data?.meta?.pagination?.total || 0,
		unpaid: unpaidRes?.data?.meta?.pagination?.total || 0,
	}
	counts.total = counts.paid + counts.unpaid
	submissionCountsCache.set(cacheKey, counts)

	return counts
}

export const clearSubmissionCountsCache = () => submissionCountsCache.clear()
